module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/diagnostics-4ac55c08cb63f77a5541d02d5c099d99.svg";